function initFeaturedKits(sectionId, options = {}) {
  const section = document.getElementById(sectionId);
  if (!section) return;

  // Get layout options from parameters
  const desktopLayout = options.desktopLayout || 'slider';
  const mobileLayout = options.mobileLayout || 'slider';

  // Create elements object with all needed selectors
  const elements = {
    buttons: section.querySelectorAll('.selector-collection-button'),
    slides: section.querySelectorAll('[data-slide]'),
    gridItems: section.querySelectorAll('[data-collection]'),
    gridContainers: section.querySelectorAll('.featured-products-grid'),
  };

  const splideInstances = {};

  // Initialize Splide for a specific collection
  const initSplideForCollection = (collectionHandle) => {
    const slides = Array.from(elements.slides).filter((slide) => slide.dataset.collection === collectionHandle);

    if (!slides.length) return;

    if (splideInstances[collectionHandle]) return;

    const container = document.createElement('div');
    container.classList.add('splide', 'featured-collections-splide');
    container.style.cssText = 'padding: 10px;';
    container.dataset.collection = collectionHandle;

    const track = document.createElement('div');
    track.classList.add('splide__track');

    const list = document.createElement('ul');
    list.classList.add('splide__list');

    slides.forEach((slide) => {
      slide.style.display = '';
      list.appendChild(slide);
    });

    track.appendChild(list);
    container.appendChild(track);
    section.appendChild(container);

    // Create Splide instance with responsive settings
    const splideInstance = new Splide(container, {
      type: 'slide',
      perPage: 4,
      perMove: 4,
      drag: 'free',
      start: 0,
      lazyload: 'sequential',
      gap: '30px',
      pagination: false,
      arrows: true,
      easing: 'cubic-bezier(.38,0,.57,1)',
      breakpoints: {
        767: {
          gap: '12px',
          perPage: 1,
          perMove: 1,
        },
        1024: {
          gap: '20px',
          perPage: 2,
          perMove: 2,
          snap: false,
          padding: { right: '30%' },
          drag: 'free',
        },
      },
      classes: {
        arrow: 'splide__arrow !tw-bg-transparent',
        prev: 'splide__arrow--prev !tw-left-[-1.75rem]',
        next: 'splide__arrow--next !tw-right-[-1.75rem]',
      },
    }).mount();

    splideInstances[collectionHandle] = splideInstance;
    splideInstance.go(0);
  };

  // Handle grid display for a specific collection
  const handleGridCollectionDisplay = (selectedHandle) => {
    elements.gridItems.forEach((item) => {
      if (item.classList.contains('featured-product-grid-item')) {
        item.style.display = item.dataset.collection === selectedHandle ? 'flex' : 'none';
      }
    });
  };

  // Handle collection change
  const handleCollectionChange = (button) => {
    const selectedHandle = button.dataset.collection;

    // Update button states
    elements.buttons.forEach((btn) => {
      btn.classList.remove('selected');
      if (btn.dataset.collection === selectedHandle) {
        btn.classList.add('selected');
      }
    });

    // Check if we're using window size to determine layout
    const isDesktopView = window.innerWidth >= 1024;
    const currentLayout = isDesktopView ? desktopLayout : mobileLayout;

    if (currentLayout === 'slider') {
      // Hide all sliders
      Object.values(splideInstances).forEach((instance) => {
        instance.root.style.display = 'none';
      });

      // Show or initialize the selected collection's slider
      const selectedInstance = splideInstances[selectedHandle];
      if (selectedInstance) {
        selectedInstance.root.style.display = 'block';
        selectedInstance.go(0);
      } else {
        initSplideForCollection(selectedHandle);
        const newInstance = splideInstances[selectedHandle];
        if (newInstance) {
          newInstance.root.style.display = 'block';
          newInstance.go(0);
        }
      }
    } else {
      // Handle grid layout
      handleGridCollectionDisplay(selectedHandle);
    }
  };

  // Initialize sliders if needed
  const uniqueCollections = new Set(Array.from(elements.slides).map((slide) => slide.dataset.collection));
  uniqueCollections.forEach((collectionHandle) => {
    // Initialize based on current viewport size
    const isDesktopView = window.innerWidth >= 1024;
    const currentLayout = isDesktopView ? desktopLayout : mobileLayout;

    if (currentLayout === 'slider') {
      initSplideForCollection(collectionHandle);
    }
  });

  // Handle grid layout initially
  if (desktopLayout === 'grid' || mobileLayout === 'grid') {
    const firstCollection = elements.buttons[0]?.dataset.collection;
    if (firstCollection) {
      handleGridCollectionDisplay(firstCollection);
    }
  }

  // Set up event listeners
  section.addEventListener('click', (e) => {
    const button = e.target.closest('.selector-collection-button');
    if (button) handleCollectionChange(button);
  });

  // Initialize with first collection
  const firstButton = elements.buttons[0];
  if (firstButton) handleCollectionChange(firstButton);

  // Handle resize events to switch between layouts if needed
  let lastWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    const currentWidth = window.innerWidth;
    const wasDesktop = lastWidth >= 1024;
    const isDesktop = currentWidth >= 1024;

    // Only take action if we crossed the desktop/mobile boundary
    if (wasDesktop !== isDesktop) {
      const firstButton = elements.buttons[0];
      if (firstButton) handleCollectionChange(firstButton);
    }

    lastWidth = currentWidth;
  });
}
